import { useEffect } from "react";

function useAutoScroll(element, enabled) {
  const scrollToBottom = () => {
    if (element?.current) {
      setTimeout(function () {
        element.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  };

  useEffect(() => {
    if (enabled) {
      scrollToBottom();
    }
  });
}

export default useAutoScroll;
